"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetOnFieldChange = exports.useResetOnFieldChange = void 0;
var react_1 = __importStar(require("react"));
var formik_1 = require("formik");
var hooks_1 = require("../../../hooks");
/**
 * ### Reseting dependant fields values if needed.
  Problem: Let's say you have Select1 and Select2 and both are async -- which means they fetch values from API.
  Now, let's say that Select2 needs the value selected in Select1 to fetch the values.
  Now, if you first select the value in `Select1` and then in `Select2` and then reset in `Select1`
  then your value in `Select2` is invalid and you need to reset it.

  Solution:
  1. Simply put, reset the values if their value was dependant on some earlier input or selection.
    The example above was given to just visualize a common case scenario.
  2. Use `useResetOnFieldChange` hook from storybook.
    import { useResetOnFieldChange } from '@wastehero/storybook/lib/components/formik-kit'
    _Why_:
    It's simple to use and gives you out of the box functionality needed to do the above described solution.
    It also allows you to set custom default values.
 */
var useResetOnFieldChange = function (field, dependants, defaultVal) {
    if (defaultVal === void 0) { defaultVal = undefined; }
    var _a = formik_1.useFormikContext(), values = _a.values, setValues = _a.setValues, dirty = _a.dirty;
    var current = values[field];
    var previous = hooks_1.usePrevious(current);
    var dependantsDefaultObject = Array.isArray(dependants)
        ? dependants.reduce(function (acc, k) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[k] = defaultVal, _a)));
        }, {})
        : dependants;
    react_1.useEffect(function () {
        if (previous !== current && dirty) {
            // we will reset the values.
            setValues(__assign(__assign({}, values), dependantsDefaultObject));
        }
    }, [
        current,
        dependantsDefaultObject,
        field,
        previous,
        setValues,
        values,
        dirty,
    ]);
};
exports.useResetOnFieldChange = useResetOnFieldChange;
var ResetOnFieldChange = function (_a) {
    var field = _a.field, dependants = _a.dependants, defaultVal = _a.defaultVal;
    exports.useResetOnFieldChange(field, dependants, defaultVal);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.ResetOnFieldChange = ResetOnFieldChange;
